import { useLazyQuery } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { TextInput } from '../../../../../components/textInput/TextInput';
import { Chip, Grid } from '@mui/material';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { useDebounce } from '../../../../../hooks/useDebounce';

import { GET_DIAGNOSTICOS_CIE_ITEMS } from '../../../../../data/graphQL/queries/ResumenIngreso/getDiagnosticosCIEItems';
import { adaptDiagnosticoItemsArray } from '../../../../../adapters/resumenIngreso/diagnosticoCIEAdapter';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import toast from 'react-hot-toast';

export const SearchDiagnosticoCIE = ({
  diagnosticosRIModel,
  handleChange,
  inputName,
  readOnly = false
}) => {

  const diagnosticosItemsColumns = generateColumnsDefaultConfiguration([
    {
      field: 'codigo',
      headerName: 'Código',
      flex: 0.2
    },
    {
      field: 'descripcion',
      headerName: 'Descripción',
      flex: 0.5,
      headerAlign: 'left',
      align: 'left'
    },
    {
      field: 'categoria',
      headerName: 'Categoría',
      flex: 0.3,
      headerAlign: 'left',
      align: 'left'
    }]
  );

  const [openModalBuscarCentro, setOpenModalBuscarCentro] = useState(false);
  const [diagnosticosSelec, setDiagnosticosSelec] = useState(diagnosticosRIModel ?? []);

  useEffect(() => {
    setDiagnosticosSelec(diagnosticosRIModel ?? []);
  }, [diagnosticosRIModel]);

  const [
    diagnosticosCIEItemsRows,
    handleChangePaginationStatusItems,
    paginationStatusItems,
    diagnosticosCIEItemsTotalCount,
    filterStatusItems,
    setFilterStatusItems,
    orderStatus,
    setOrderStatus] =
    useGetDiagnosticosItems();

  const handleSearchCentro = () => setOpenModalBuscarCentro(true);
  const handleCloseSearchCentro = () => setOpenModalBuscarCentro(false);

  const resetAllFilterValues = () => {
    handleCloseSearchCentro();
    setFilterStatusItems('');
    handleChangePaginationStatusItems({
      pageSize: 5,
      page: 0
    });
  };

  const handleSelectItem = (row) => {
    if (diagnosticosSelec.find((d) => d.codigoItem === row.row.codigo)) {
      toast.error('El diagnóstico ya fue seleccionado');
      return;
    }
    const diagnosticoCompleto = {
      codigo: row.row.codigoDiagnostico,
      codigoItem: row.row.codigo,
      descripcionItem: row.row.descripcion,
      categoria: row.row.categoria
    };
    setDiagnosticosSelec((prevDiags) => {
      const nuevosDiagnosticos = [...prevDiags, diagnosticoCompleto];
      handleChange(inputName || 'diagnosticosRI', nuevosDiagnosticos);
      return nuevosDiagnosticos;
    });
    resetAllFilterValues();
  };

  const onDeleteDiagnostico = (codigoItem) => {
    setDiagnosticosSelec((prevDiags) => {
      const nuevosDiagnosticos = prevDiags.filter((x) => x.codigoItem !== codigoItem);
      handleChange(inputName || 'diagnosticosRI', nuevosDiagnosticos);
      return nuevosDiagnosticos;
    });
  };

  const handleSortChange = (sortModel) => {
    if (sortModel.length === 0) return;
    const sort = sortModel[0];
    const direction = sort.sort === 'asc' ? 'ASC' : 'DESC';

    const mapFieldToGraphQL = {
      codigo: 'cod_DiagnosticoCIEItem',
      descripcion: 'descripcion',
      categoria: 'cod_DiagnosticoCIENavigation.descripcion'
    };

    if (sort.field === 'categoria') {
      setOrderStatus({
        field: 'cod_DiagnosticoCIENavigation',
        nested: 'descripcion',
        direction
      });
    } else {
      setOrderStatus({
        field: mapFieldToGraphQL[sort.field] || 'cod_DiagnosticoCIEItem',
        direction
      });
    }
  };

  return (
    <>
      <TextInput
        label={`Diagnóstico CIE-10`}
        onClick={handleSearchCentro}
        placeholder='Buscar'
        searchIcon
        sx={{ mt: 2.5 }}
        disabled={readOnly} />

      {diagnosticosSelec.map((diagnostico) =>
        <Chip
          key={`${diagnostico.descripcionItem}-${diagnostico.codigoItem}`}
          label={diagnostico.descripcionItem}
          onDelete={() => !readOnly && onDeleteDiagnostico(diagnostico.codigoItem)}
          sx={{ mr: 1, mt: 1 }} />

      )}
      <CustomDialog
        open={openModalBuscarCentro}
        maxWidth='md'
        fullWidth
        title={`Agregar diagnóstico`}
        onCancel={handleCloseSearchCentro}>

        <Grid container justifyContent={'space-between'}>
          <Grid size={{ xs: 12 }}>
            <div className='grid-resumen-ingreso-title'>
              <div>Haz click sobre un ítem para agregarlo y seguir con el formulario</div>
            </div>
          </Grid>
          <Grid sx={{ my: 2.5 }} size={{ xs: 12 }}>
            <TextInput
              placeholder='Filtrar'
              value={filterStatusItems}
              searchIcon
              onChange={(e) => setFilterStatusItems(e.target.value)}
              onClearButtonClick={() => setFilterStatusItems('')} />

          </Grid>
          <Grid size={{ xs: 12 }}>
            <DataGridGenerico
              hideFooterPagination={false}
              toolbar={false}
              columns={diagnosticosItemsColumns}
              rows={diagnosticosCIEItemsRows}
              onPageChange={(page) =>
                handleChangePaginationStatusItems((prev) => ({
                  ...prev,
                  page: page
                }))
              }
              onPageSizeChange={(pageSize) =>
                handleChangePaginationStatusItems((prev) => ({
                  ...prev,
                  pageSize: pageSize,
                  page: 0
                }))
              }
              pageSize={paginationStatusItems.pageSize}
              totalCount={diagnosticosCIEItemsTotalCount}
              currentPage={paginationStatusItems.page}
              onRowClick={handleSelectItem}
              onSortModelChange={handleSortChange} />

          </Grid>
        </Grid>
      </CustomDialog>
    </>);

};

const useGetDiagnosticosItems = () => {
  const [diagnosticosItems, setDiagnosticosItems] = useState([]);
  const [paginationStatusItems, setPaginationStatusItems] = useState({ pageSize: 5, page: 0 });
  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);
  const [orderStatus, setOrderStatus] = useState({ field: 'cod_DiagnosticoCIEItem', direction: 'ASC' });

  const [getDiagnosticosItems, { loading: diagnosticosItemsLoading, data: diagnosticosItemsData }] = useLazyQuery(GET_DIAGNOSTICOS_CIE_ITEMS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!diagnosticosItemsData) return;

    setDiagnosticosItems(diagnosticosItemsData);
  }, [diagnosticosItemsData]);

  useEffect(() => {
    if (!diagnosticosItemsLoading) {
      getDiagnosticosItems({
        variables: {
          skip: paginationStatusItems.page * paginationStatusItems.pageSize,
          take: paginationStatusItems.pageSize,
          where: {
            or: [
              { cod_DiagnosticoCIENavigation: { descripcion: { contains: debouncedFilterValue } } },
              { cod_DiagnosticoCIEItem: { contains: debouncedFilterValue } },
              { descripcion: { contains: debouncedFilterValue } }]

          },
          order: [
            orderStatus.nested ?
              { [orderStatus.field]: { [orderStatus.nested]: orderStatus.direction } } :
              { [orderStatus.field]: orderStatus.direction }]

        }
      });
    }
  }, [paginationStatusItems, debouncedFilterValue, orderStatus]);

  return [
    adaptDiagnosticoItemsArray(diagnosticosItems) || [],
    setPaginationStatusItems,
    paginationStatusItems,
    diagnosticosItems?.allDiagnosticoCIEItems?.totalCount,
    filterStatus,
    setFilterStatus,
    orderStatus,
    setOrderStatus];

};